import { cn, Image } from "@quint/ui";

import Badge from "public/images/luxury/badge-coins-2.png";
import CoinsShadow from "public/images/luxury/coins-shadow.png";
import Flash from "public/images/luxury/flash.png";
import HeroTitle from "public/images/luxury/luxury-hero-title.png";
import Stars from "public/images/luxury/stars.png";
import Winner from "public/images/luxury/winner.png";

function LuxuryHero() {
  return (
    <div className="relative flex w-full flex-col items-center justify-end">
      <div className="relative mb-[-20px] flex justify-center md:mb-[-50px]">
        <Image
          priority
          loading="eager"
          src={HeroTitle}
          alt="Luxury Raffle Pool B"
          height={72}
          width={576}
          sizes="(max-width: 576px) 100vw, 576px"
          className={cn(["absolute top-[-75%] mb-[100px] w-[100%] lg:w-[60%]"])}
        />
        <Image
          priority
          loading="eager"
          src={Winner}
          alt="winner text"
          width={570}
          sizes="(max-width: 570px) 100vw, 570px"
          height={104}
          className={cn([" absolute top-[-25%] z-[2] w-[60%]"])}
        />
        <Image
          priority
          loading="eager"
          src={Badge}
          alt="Badge"
          placeholder="blur"
          width={966}
          sizes="(max-width: 966px) 100vw, 966px"
          height={330}
          className="z-[1]"
        />
        <Image
          priority
          loading="eager"
          src={CoinsShadow}
          alt="CoinsShadow"
          placeholder="blur"
          width={966}
          sizes="(max-width: 966px) 100vw, 966px"
          height={330}
          className="absolute z-[0] mix-blend-multiply"
        />
        <Image
          priority
          loading="eager"
          src={Flash}
          alt="Luxury Flash"
          height={1102}
          sizes="(max-width: 966px) 100vw, 966px"
          className={cn(["absolute top-[-90%] z-[-1]  mix-blend-lighten"])}
        />
        <div className={cn(["absolute  bottom-[45%] z-[3] "])}>
          <h1
            className={cn([
              " text-center font-satoshi font-bold text-white ",
              "text-[2.2vw] lg:text-[2.4vw] xl:text-[1.7vw] 2xl:text-[1.4vw]",
            ])}
          >
            0xfD935E1FC4B1D97e4364898FEA57729b44042d1d
          </h1>
          <h2
            className={cn([
              "text-center font-satoshi font-medium tracking-[-0.03rem] text-primary",
              "text-[2.2vw] lg:text-[2.4vw] xl:text-[1.7vw] 2xl:text-[1.4vw]",
            ])}
          >
            Congratulations to the winning wallet
          </h2>
        </div>
      </div>

      <Image
        priority
        loading="eager"
        src={Stars}
        alt="Stars"
        width={1097}
        sizes="(max-width: 1097px) 100vw, 1097px"
        height={433}
        className={cn([" absolute  z-[3]   mix-blend-lighten"])}
      />
    </div>
  );
}

export default LuxuryHero;
